import { Box } from "@mui/material";
import { SKIN_FADE_IN_MS, SKIN_FADE_OUT_MS, useSkinFadeStore } from "state/themeState/skin-fade.store";

/**
 * Full-screen veil covering the skin swap. Rendered inside the portaled subtree so every
 * native view fades its own copy, and outside ThemeRemountGate so the remount does not
 * restart it.
 */
export default function SkinFadeLayer() {
  const active = useSkinFadeStore((s) => s.active);
  const colour = useSkinFadeStore((s) => s.colour);

  return (
    <Box
      aria-hidden
      sx={{
        position: "fixed",
        inset: 0,
        pointerEvents: "none",
        background: colour,
        opacity: active ? 1 : 0,
        transition: `opacity ${active ? SKIN_FADE_IN_MS : SKIN_FADE_OUT_MS}ms ease`,
        zIndex: (theme) => theme.zIndex.modal + 2,
      }}
    />
  );
}
